import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M14.592 6.861a.258.258 0 01-.155-.205.321.321 0 010-.27l.837-1.081a.529.529 0 00.064-.116 1.491 1.491 0 00-.026-1.492 1.454 1.454 0 00-1.286-.682h-5.39a1.454 1.454 0 00-1.223.682 1.492 1.492 0 00-.077 1.466.527.527 0 000 .116l.836 1.08a.322.322 0 010 .27.257.257 0 01-.039.232C4.633 8.881 3 11.571 3 15.237c0 3.667 3.05 5.777 8.363 5.777s8.362-2.097 8.362-5.764c0-3.667-1.634-6.369-5.133-8.389zm-2.985 6.022c.888.386 2.007.862 2.007 2.02 0 1.157-.695 1.608-1.286 1.698a.308.308 0 00-.284.321v.734a.643.643 0 11-1.286 0v-.708a.322.322 0 00-.322-.322h-.643a.695.695 0 010-1.376h2.239a.322.322 0 00.296-.335c0-.218-.811-.566-1.21-.733-.888-.399-2.007-.888-2.007-2.033a1.647 1.647 0 011.364-1.66.334.334 0 00.244-.321v-.733a.643.643 0 111.287 0v.72a.322.322 0 00.322.322h.643a.695.695 0 010 1.376h-1.93c-.103 0-.643 0-.643.348 0 .347.81.514 1.21.682z",
      fill: "#333"
    }
  )
);
export {
  t as default
};
